var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinner(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3689_17702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1275 15.2874V17.127H16.5883V18.9114H5.8824V17.127H10.3432V15.2874C8.61838 15.0699 7.03223 14.2305 5.8824 12.9265C4.73258 11.6226 4.09812 9.94395 4.09809 8.20548V2.85254H18.3726V8.20548C18.3726 9.94395 17.7381 11.6226 16.5883 12.9265C15.4385 14.2305 13.8523 15.0699 12.1275 15.2874ZM1.42162 4.63685H3.20593V8.20548H1.42162V4.63685ZM19.2648 4.63685H21.0491V8.20548H19.2648V4.63685Z",
    fill: "#00AC79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3689_17702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4118,
    height: 21.4118,
    fill: "white",
    transform: "translate(0.529449 0.176025)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.75c27e35ce2ba7f33c7752933948070c.svg";
export { ForwardRef as ReactComponent };